import { ReactNode } from 'react';

/**
 * Section titrée à l'intérieur d'un formulaire.
 *
 * Regroupe visuellement les champs par catégorie avec un titre, une icône
 * optionnelle et une description courte.
 *
 * Exemple :
 *   <FormSection title="Identité" icon={<Person />} subtitle="Informations personnelles">
 *       <TextField ... />
 *       <TextField ... />
 *   </FormSection>
 */
const FormSection = (props: {
    title: ReactNode;
    icon?: ReactNode;
    subtitle?: ReactNode;
    children: ReactNode;
}) => (
    <div className="eb-form-section">
        <div className="eb-form-section-head">
            {props.icon && <span className="eb-form-section-icon">{props.icon}</span>}
            <div>
                <h3 className="eb-form-section-title">{props.title}</h3>
                {props.subtitle && <p className="eb-form-section-subtitle">{props.subtitle}</p>}
            </div>
        </div>
        <div className="eb-form-grid">
            {props.children}
        </div>
    </div>
);

export default FormSection;
